<template>
	<div>
		<a-table size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="pid" 
			:pagination="false" :scroll="{y:500}">
			<span slot="readTimeSlot" slot-scope="text, record">
				{{getTimeFormatter(record.create_time)}}
			</span>
		</a-table>
	</div>
</template>

<script>
	const columns = [
		{ title: '减免时间', dataIndex: 'create_time',width:140,scopedSlots:{customRender:'readTimeSlot'}},
		{ title: '减免数量', dataIndex: 'minus_count',width:90},
	];
	export default{
		props:['mdlId','customerId'],
		data(){
			return{
				columns,
				list:[],
				loading:true,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.CHARGE_MINUS_DEREAD_LOG_LIST_URL);
				let param = {theId:this.mdlId,customerId:this.customerId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
		},
		mounted() {
			this.queryDataList();
		},
	}
</script>

<style>
</style>
